import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CommissionStore } from '../service';
import { FlashMessagesService } from 'app/shared/flash-messages/service/flash.messages.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs/Observable';
import { LogService } from 'app/shared/log/log.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Component({
  selector: 'pioneer-payment-title-summary',
  templateUrl: './payment-title-summary.component.html',
})
export class PaymentTitleSummaryComponent implements OnInit, OnDestroy {

  @Input() iconClass: string;
  @Input() title: string;
  @Input() isCompleted: boolean;
  @Input() summary: string;
  @Input() summary2: string;
  @Input() invoiceGenerated: string;
  @Input() pendingWorkflow: boolean;

  private _resendPaymentRequestAllowed$ = new BehaviorSubject<boolean>(false);
  get resendPaymentRequestAllowed$(): Observable<boolean> {
    return this._resendPaymentRequestAllowed$.asObservable();
  }

  private _resendPaymentRequestDisabled$ = new BehaviorSubject<boolean>(true);
  get resendPaymentRequestDisabled$(): Observable<boolean> {
    return this._resendPaymentRequestDisabled$.asObservable();
  }

  private _isLoading$ = new BehaviorSubject<boolean>(true);
  get isLoading$(): Observable<boolean> {
    return this._isLoading$.asObservable();
  }

  constructor(
    private commissionStore: CommissionStore,
    private flashMessagesService: FlashMessagesService,
    private logService: LogService
  ) { }

  ngOnInit() {
    this._isLoading$.next(true);
    this._resendPaymentRequestAllowed$.next(false);
    this._resendPaymentRequestDisabled$.next(true);

    this.commissionStore.isResendPaymentRequestAllowed().pipe(
      take(1),
      map(
        (response: { resendPaymentRequestAllowed: boolean; }) => {
          return !!response ? response.resendPaymentRequestAllowed : false;
        }
      )
    ).subscribe(
      (resendPaymentRequestAllowed: boolean) => {
        this._resendPaymentRequestAllowed$.next(resendPaymentRequestAllowed);

        if (resendPaymentRequestAllowed) {
          this._resendPaymentRequestDisabled$.next(false);
        } else {
          this._resendPaymentRequestDisabled$.next(true);
        }
      },
      (err) => {
        this.logService.error(`Error in isResendPaymentRequestAllowed: ${JSON.stringify(err)}`);
        this.flashMessagesService.error('MESSAGES.ERROR.IS_RESEND_PAYMENT_REQUEST_ALLOWED');
        this._resendPaymentRequestDisabled$.next(true);
      },
      () => this._isLoading$.next(false)
    );
  }

  ngOnDestroy(): void {
    this._resendPaymentRequestAllowed$.complete();
    this._resendPaymentRequestDisabled$.complete();
    this._isLoading$.complete();
  }

  print(event) {
    window.print();
  }

  resendPaymentRequest() {
    this._resendPaymentRequestDisabled$.next(true);
    this.commissionStore.resendPaymentRequest().pipe(
      take(1)
    ).subscribe(
      () => this.flashMessagesService.success('MESSAGES.SUCCESS.PAYMENT_REQUEST_RESENT'),
      (err) => {
        this.logService.error(`Error in resendPaymentRequest: ${JSON.stringify(err)}`);
        this.flashMessagesService.error('MESSAGES.ERROR.PAYMENT_REQUEST_RESENT');
        this._resendPaymentRequestDisabled$.next(false);
      }
    );
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-title-summary/payment-title-summary.component.ts